import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "TriangleDown",
  "use": "TriangleDown-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"TriangleDown\"><path d=\"M32 50L1 13h62z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol